<script lang="ts">
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"
  import type {
    PlanningPreviewRow,
    PlanningPreviewRowChange,
  } from "../../../../../../_shared/_logic/table-contract"

  type Props = {
    row: PlanningPreviewRow
    disabled?: boolean
    onChange: (row: PlanningPreviewRow, change: PlanningPreviewRowChange) => void
  }

  let { row, disabled = false, onChange }: Props = $props()

  const selectedOption = $derived(
    row.appointmentEmployeeOptions.find((option) => option.value === row.appointmentEmployeeId) ??
      null,
  )
  const readonlyLabel = $derived(
    selectedOption?.shortLabel ?? selectedOption?.label ?? "Kein Mitarbeiter",
  )
  const readonlyTooltip = $derived(
    selectedOption?.tooltipLabel ?? selectedOption?.label ?? "Kein Mitarbeiter",
  )
  const toggleOptions = $derived(
    row.appointmentEmployeeOptions.map((option) => {
      const label = option.tooltipLabel ?? option.label

      return {
        value: option.value,
        label: option.shortLabel ?? option.label,
        ariaLabel: `${label} als Terminmitarbeiter auswählen`,
        tooltipContent: `Terminmitarbeiter: ${label}`,
      }
    }),
  )
</script>

{#if row.appointmentEmployeeEditable && toggleOptions.length > 1}
  <div class="employee-toggle-cell" aria-label="Terminmitarbeiter">
    {#key row.appointmentEmployeeId || "empty"}
      <ToggleCTA
        options={toggleOptions}
        value={row.appointmentEmployeeId || null}
        allowEmptySelection={true}
        small={true}
        darkMode={false}
        {disabled}
        onChange={(value) => onChange(row, { kind: "appointment_employee", value: value || null })}
      />
    {/key}
  </div>
{:else}
  <span class="readonly-cell" title={readonlyTooltip}>{readonlyLabel}</span>
{/if}

<style lang="less">
  .employee-toggle-cell {
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
  }

  .employee-toggle-cell :global(.toggle-cta) {
    max-width: 100%;
  }

  .employee-toggle-cell :global(button.cta.toggle) {
    min-width: 2.1rem;
    padding-inline: 0.45rem;
  }

  .readonly-cell {
    display: inline-block;
    max-width: 5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--text-invers-100);
    font-weight: 800;
  }
</style>
